module.exports = {
  BUSINESS_ESTABLISHMENT: 'BUSINESS_ESTABLISHMENT',
  WITHDRAW_SERVICE: 'WITHDRAW_SERVICE',
  OTHER_SERVICE: 'OTHER_SERVICE'
};
